import React, { FC } from 'react'
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom'
import { TenantPage } from './page'

export const TENANT_FORM_ROUTES = {
  TENANT_BASED: '',
  TENANT_FORM: '/*',
  TENANT_FORM_WELCOME: '/:recipientId',
  TENANT_FORM_STEPS: '/:recipientId/:stepsId',
  TENANT_FORM_REQUEST_SUBMITED: '/:recipientId/succes/changed-request',
  TENANT_FORM_BROKEN_LINK: '/:recipientId/broken-link',
}

export const MainRouter: FC = () => {
  const router = createBrowserRouter(
    createRoutesFromElements(<Route path={TENANT_FORM_ROUTES.TENANT_BASED}>{TenantPage()}</Route>),
  )
  return <RouterProvider router={router} />
}
